import * as C from '../common/constants';
import * as ROUTES from '../common/routes';
import Checkbox from '@mui/material/Checkbox';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import MuiDialogContent from '@mui/material/DialogContent';
import React, { useState } from 'react';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { getText } from '../common/utils/helpers';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslations } from '../common/hooks/useTranslations';

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      rulesContainerStyle: {
        position: 'relative',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        marginTop: '20px',
      },
      rulesWrapperStyle: {
        display: 'flex',
        flexWrap: 'wrap',
      },
      rulesTextStyle: {
        fontFamily: FONTS.alegreya,
        fontSize: '14px',
        color: COLORS.textBlack,
        paddingRight: '6px',
      },
      rulesLinkStyle: {
        fontFamily: FONTS.alegreya,
        fontSize: '14px',
        color: COLORS.appBlue,
        textDecoration: 'underline',
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            opacity: 0.7,
            transition: '0.5s ease',
          },
        },
      },
      dialogContainerStyle: {
        '& > div > div': {
          maxWidth: `${C.MAX_WIDTH}px`,
          width: '100%',
          background: COLORS.white,
        },
      },
      closeButtonStyle: {
        position: 'absolute',
        right: 20, // theme.spacing(2),
        top: 20, // theme.spacing(2),
        fill: COLORS.textGray,
        width: '40px',
        height: '40px',
        pointerEvents: 'auto',
        zIndex: 100,
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            opacity: 0.7,
            transition: '0.5s ease',
          },
        },
      },
      dialogContentStyle: {
        margin: '16px',
        color: COLORS.textBlack,
        padding: '30px',
      },
      textStyle: {
        fontWeight: FONT_WEIGHT.medium,
        fontSize: '16px',
        lineHeight: '22px',
        fontFamily: FONTS.alegreya,
        color: COLORS.textBlack,
      },
    })
);

const RulesAgreement = ({ onChange, isChecked }): JSX.Element => {
  const classes = useStyles();
  const lng = useSelector((state: any) => state.app.lng);
  const appData = useSelector((state: any) => state.app.appData);

  const rulesTextLabel = useTranslations('rules_text');
  const rulesLinkLabel = useTranslations('rules_link');

  const [isDialogOpen, setDialog] = useState(false);

  if (!appData) {
    return null;
  }

  const label = { inputProps: { 'aria-label': 'Noteikumi' } };

  const rulesData = appData.find((item) => item.content.uid === 'noteikumi');
  const rulesText: string = getText(rulesData?.content, 'text', lng);
  const text: string = rulesText.replace(/(?:\r\n|\r|\n)/g, '<br>');

  const handleChange = (event) => {
    onChange(event.target.checked);
  };

  const isMobile = window.innerWidth < 900;

  const onClick = (event: React.SyntheticEvent) => {
    event.stopPropagation();
    event.preventDefault();

    setDialog(true);
  };

  const onClose = (event?: React.SyntheticEvent) => {
    event?.stopPropagation();
    event?.preventDefault();

    setDialog(false);
  };

  return (
    <div className={classes.rulesContainerStyle}>
      <Checkbox {...label} checked={isChecked} onChange={handleChange} />
      <div className={classes.rulesWrapperStyle}>
        <div className={classes.rulesTextStyle}>{rulesTextLabel}</div>
        <div className={classes.rulesLinkStyle} onClick={onClick}>
          {rulesLinkLabel}
        </div>
      </div>
      <Dialog
        fullScreen={isMobile}
        open={isDialogOpen}
        onClose={onClose}
        className={classes.dialogContainerStyle}
      >
        <CloseIcon className={classes.closeButtonStyle} onClick={onClose} />
        <MuiDialogContent className={classes.dialogContentStyle}>
          <div
            className={classes.textStyle}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        </MuiDialogContent>
      </Dialog>
    </div>
  );
};

export default RulesAgreement;
